function initFaqAccordions() {
  const accordionGroups = document.querySelectorAll("[data-accordion-group]");

  if (!accordionGroups.length) {
    return;
  }

  accordionGroups.forEach((group) => {
    const items = group.querySelectorAll(".faq-accordion-item");
    const headers = group.querySelectorAll(".faq-accordion-header");

    headers.forEach((header, index) => {
      header.addEventListener("click", () => {
        const currentItem = items[index];
        const isActive = currentItem.classList.contains("is-active");

        // Close all other items in the same group
        items.forEach((item, itemIndex) => {
          if (index !== itemIndex) {
            item.classList.remove("is-active");
            item
              .querySelector(".faq-accordion-header")
              .setAttribute("aria-expanded", "false");
          }
        });

        // Toggle the clicked item
        if (isActive) {
          currentItem.classList.remove("is-active");
          header.setAttribute("aria-expanded", "false");
        } else {
          currentItem.classList.add("is-active");
          header.setAttribute("aria-expanded", "true");
        }
      });
    });
  });
}

// Run the initialization
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initFaqAccordions();
} else {
  document.addEventListener("DOMContentLoaded", initFaqAccordions);
}
